import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent.js'
import Navigation from '../Navigation/Navigation.js'
import NoContent from '../NoContent/NoContent.js'
import Landing from '../Landing/Landing.js'
import NotAuthorized from '../NotAuthorized/NotAuthorized.js'
import AuthorizationFilter from '../Authorization/AuthorizationFilter.js'
import Testformular from "../WBF/ISCeco/Testformular/Testformular";
import FDR from "../WBF/BWO/FDR/FDR"
import Dashboard from "../Dashboard/Dashboard"
import StatutenPruefung from "../WBF/BWO/statutenpruefung/StatutenPruefung";
import Monitoring from "../Monitoring/Monitoring";
import Beschwerdeformular from '../WBF/SECO/Beschwerdeformular/Beschwerdeformular'
import Administration from "../Administration/Administration";
import AdministrationEdit from "../AdministrationEdit/AdministrationEdit";
import Sbfi from "../WBF/SBFI/Sbfi";
import Gesuch from "../WBF/SBFI/Gesuch/Gesuch";
import Reporting from "../WBF/SBFI/Reporting/Reporting";
import Projektfinanzierungsgesuch from "../WBF/SBFI/Projektfinanzierungsgesuch/Projektfinanzierungsgesuch";
import Nachtrag from "../WBF/Nachtrag/Nachtrag";
import Forschungsgesuch from "../WBF/BWO/Forschungsgesuch/Forschungsgesuch";
import SasBeschwerdeformular from "../WBF/SECO/SAS/Beschwerdeformular/SasBeschwerdeformular";

export default class MainView extends WebComponent {

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.oldChild = null
    this.navigationListener = e => {
      // split is used if we have vertical submenu navigation
      this.loadView(e.detail)
    }
    document.addEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)

    this.loadView(getNavigationHash())
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.removeEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)
  }

  loadView(linkName) {
    if (isEmpty(linkName)) {
      this.redirectToDefault()
    } else {
      const newChild = this.returnNewChild(linkName)
      if (this.oldChild) {
        this.root.replaceChild(newChild, this.oldChild)
      } else {
        this.root.appendChild(newChild)
      }

      this.oldChild = newChild
    }
  }

  returnNewChild(linkName) { //NOSONAR
    if (!new AuthorizationFilter().viewAllowed(linkName)) {
      return new NotAuthorized()
    }
    switch (linkName) {
      case '':
      case 'Landing':
        return new Landing()
      case 'Dashboard':
        return new Dashboard()
      case 'Monitoring':
        return new Monitoring()
      case 'Administration':
        return new Administration()
      case 'AdministrationEdit':
        return new AdministrationEdit()
      case 'wbf-isceco-testformular':
        return new Testformular()
      case 'wbf-bwo-fdr':
        return new FDR()
      case 'wbf-bwo-statutenpruefung':
        return new StatutenPruefung()
      case 'wbf-bwo-forschungsgesuch':
        return new Forschungsgesuch()
      case 'wbf-seco-beschwerdeformular':
        return new Beschwerdeformular()
      case 'wbf-seco-sas-beschwerdeformular':
        return new SasBeschwerdeformular()
      case 'wbf-sbfi-gesuchformular':
        return new Sbfi()
      case 'wbf-sbfi-gesuchformular-gesuch':
        return new Gesuch()
      case 'wbf-sbfi-gesuchformular-reporting':
        return new Reporting()
      case 'wbf-sbfi-projektfinanzierungsgesuch':
        return new Projektfinanzierungsgesuch()
      case 'wbf-nachtrag':
        return new Nachtrag()

      default:
        return new NoContent()
    }
  }

  redirectToDefault() {
    navigate({to: 'Landing'})
  }

  getTemplate() {
    return html`eform-frontend-main-view`
  }

}

customElements.define('eform-frontend-main-view', MainView)
